import { useEffect, useState } from 'react';
import { healthApi } from '@/lib/api/endpoints';

/** Fetches `/api/health` once to surface OpenAI key readiness for owner UI hints. */
export function useOpenAiStatus(enabled = true) {
  const [openaiConfigured, setOpenaiConfigured] = useState<boolean | null>(null);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    void healthApi
      .get()
      .then((health) => {
        if (!cancelled) setOpenaiConfigured(health.openai_configured);
      })
      .catch(() => {
        if (!cancelled) setOpenaiConfigured(null);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return {
    openaiConfigured,
    showUnconfiguredHint: openaiConfigured === false,
  };
}
